import Popup from 'components/Popup/Popup'
import TermsOfServices from '../../components/TermsOfServices'
import { useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { setLoading } from '../../redux/store/common/slice'
import './style.scss'
import Typography from '../../components/Typography/Typography'
import Logo from 'assets/svg/LogoTerms.svg'
import useRouter from '../../hooks/useRouter'

const TermsOfUsePage = (): JSX.Element => {
  const dispatch = useDispatch()
  const { push } = useRouter()
  useEffect(() => {
    dispatch(setLoading(false))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const handleRedirect = () => push(-1)
  return (
    <Popup.Terms
      visible={true}
      wrapClassName={'terms-wrap-modal'}
      footer={null}
      closable={true}
      onCancel={handleRedirect}
      title={
        <img
          className="sign-popup__logo terms-logo"
          onClick={handleRedirect}
          src={Logo}
          alt="Logo"
        />
      }
    >
      <div className="terms-of-use-wrapper container">
        <div className="terms-of-use-wrapper__header">
          <Typography.Headline3>
            OM Community™ Terms of Use
          </Typography.Headline3>
          <Typography.Body2 className="soft-gray-text">
            Updated August 10, 2026
          </Typography.Body2>
        </div>
        <TermsOfServices />
      </div>
    </Popup.Terms>
  )
}

export default TermsOfUsePage
